// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Popup_overlay__7xUFz","popup":"Popup_popup__weO_V","agenda":"Popup_agenda__1i0q3","title":"Popup_title__dkxtC","closeIcon":"Popup_closeIcon__GiQ-l"};